export default {
  // Form Title & Actions
  createPetProfile: "建立寵物檔案",
  editPet: "編輯寵物",
  back: "返回",
  previous: "上一步",
  next: "下一步",
  complete: "完成並儲存",
  saving: "儲存中...",
  saved: "已儲存！",
  autoSaved: "自動儲存",
  saveProgress: "儲存進度",
  autoSaveEnabled: "已啟用自動儲存",
  saveFailed: "儲存失敗",
  saveDataError: "儲存資料失敗",
  retry: "重試",
  close: "關閉",
  cancel: "取消",
  ok: "確定",
  
  // Steps
  step: "步驟",
  basicDetails: "基本資料",
  physicalTraits: "外觀特徵",
  careNeeds: "照護需求",
  healthRecords: "健康紀錄",
  review: "檢視與完成",
  
  // Tips & Help
  showTips: "顯示提示",
  hideTips: "隱藏提示",
  preview: "預覽",
  backToEditMode: "返回編輯模式",
  tagOperationHint: "按 Enter 或逗號新增標籤,貼上多個項目會自動分割",
  
  // Basic Info
  basicInfoTips: "讓我們從基本資料開始 - 您的寵物名稱、類型和基本資訊",
  petPhoto: "寵物照片",
  uploading: "上傳中...",
  enterPetName: "輸入您的寵物名稱",
  name: "名稱",
  nameRequired: "名稱為必填",
  nameHelpText: "例如:小白、Lucky、咪咪、皮皮",
  type: "寵物類型",
  typeRequired: "寵物類型為必填",
  breed: "品種",
  specificBreed: "例如:黃金獵犬、波斯貓",
  breedHelpText: "例如:柴犬、拉布拉多、英國短毛貓、暹羅貓、虎皮鸚鵡",
  birthDate: "出生日期",
  yearLabel: "年",
  monthLabel: "月",
  dayLabel: "日",
  selectYear: "年份",
  selectMonth: "月份",
  selectDay: "日期",
  currentAge: "目前年齡",
  age: "年齡",
  birthDateCannotBeFuture: "出生日期不能是未來",
  birthDateTooOld: "出生日期似乎太久遠(最多 {maxAge} 年)",
  gender: "性別",
  genderHelpText: "選擇您的寵物性別",
  male: "公",
  female: "母",
  notSpecified: "未指定",
  microchipId: "晶片編號",
  enterMicrochipId: "輸入晶片號碼",
  microchipHelpText: "例如:982000123456789(15位數字)",
  registrationId: "登記編號",
  registrationIdHelpText: "例如:政府登記證號、寵物協會會員編號",
  currentLocation: "目前位置",
  currentLocationHelpText: "例如:台北市信義區、寄養在朋友家、動物醫院",
  
  // Pet Type Descriptions
  dog: "狗",
  cat: "貓",
  bird: "鳥",
  fish: "魚",
  rabbit: "兔子",
  hamster: "倉鼠",
  guinea_pig: "天竺鼠",
  reptile: "爬蟲類",
  turtle: "烏龜",
  other: "其他",
  
  // Physical Traits
  physicalCharacteristicsDesc: "記錄您的寵物外觀特徵以便健康追蹤",
  weight: "體重",
  enterWeight: "例如:15 公斤",
  weightHelpText: "建議定期測量並記錄,有助於健康管理",
  height: "身高",
  enterHeight: "例如:45 公分",
  heightHelpText: "測量肩高(從地面到肩膀的高度)",
  color: "毛色",
  colorExample: "例如:金色、黑白相間",
  colorHint: "例如:金色、棕色、黑色、白色、灰色、花斑、虎斑",
  coatType: "毛髮類型",
  coatTypeHint: "例如:短毛、長毛、捲毛、絲滑、粗糙、雙層毛、無毛",
  eyeColor: "眼睛顏色",
  eyeColorHint: "例如:棕色、藍色、綠色、琥珀色、異色瞳(鴛鴦眼)",
  bodySize: "體型大小",
  bodySizeHint: "例如:迷你型、小型、中型、大型、巨型",
  specialMarkings: "特殊標記",
  specialMarkingsHint: "例如:左耳有缺角、胸前白色愛心、尾巴尖端是白色、額頭有黑點",
  
  // Care Needs
  dietaryTips: "設定餵食時間表和照護需求",
  dietaryInfo: "飲食資訊",
  feedingSchedule: "餵食時間表",
  addMeal: "新增餵食",
  time: "時間",
  timeHint: "設定餵食時間,例如:早上8點、下午6點",
  portionSize: "份量",
  portionSizeExample: "例如:1 杯",
  portionSizeHint: "記錄每餐份量,例如:1杯、200克、半碗、2湯匙",
  foodType: "食物類型",
  foodTypeHint: "記錄食物種類,例如:乾糧、濕食、鮮食、零食",
  noMealsAdded: "尚未新增餵食時間。點擊「新增餵食」開始。",
  canEat: "可以吃",
  canEatHelpText: "列出寵物可安全食用的食物",
  canEatHint: "例如:雞肉、牛肉、南瓜、地瓜、藍莓、蘋果(去籽)、紅蘿蔔",
  cannotEat: "不可以吃",
  cannotEatHelpText: "列出寵物應該避免的食物",
  cannotEatHint: "例如:巧克力、洋蔥、葡萄、酪梨、木醣醇、咖啡、大蒜",
  
  behaviorInfo: "行為資訊",
  likes: "喜好",
  whatPetEnjoys: "您的寵物喜歡什麼?",
  likesHint: "例如:玩球、游泳、追逐、抓老鼠玩具、曬太陽、被摸肚子",
  dislikes: "厭惡",
  whatMakesPetUncomfortable: "什麼會讓您的寵物不舒服?",
  dislikesHint: "例如:洗澡、剪指甲、吹風機、陌生人、其他動物、雷聲",
  temperament: "性格",
  temperamentExample: "例如:友善、害羞、活潑",
  temperamentHint: "例如:友善、溫和、活潑、害羞、獨立、黏人、好動、安靜",
  exerciseNeeds: "運動需求",
  exerciseExample: "例如:每天散步 30 分鐘",
  exerciseNeedsHint: "例如:每天散步2次、需要大空間奔跑、喜歡游泳、適合公寓飼養",
  
  // Health Records
  healthTips: "追蹤藥物和健康資訊",
  healthInfo: "健康資訊",
  medicationSchedule: "用藥時間表",
  addMedication: "新增藥物",
  medicationName: "藥物名稱",
  medicationPlaceholder: "例如:抗生素",
  medicationNameHint: "輸入藥物名稱,例如:心絲蟲預防藥、抗生素、關節保健品",
  dosage: "劑量",
  dosagePlaceholder: "例如:10mg",
  dosageHint: "記錄用藥劑量,例如:10mg、1顆、5ml、半錠",
  frequency: "頻率",
  frequencyHint: "選擇用藥頻率:每日、每日兩次、每週或自訂",
  daily: "每日",
  twiceDaily: "每日兩次 (BID)",
  thriceDaily: "每日三次 (TID)",
  weekly: "每週",
  monthly: "每月",
  custom: "自訂",
  dosageTimes: "給藥時間",
  dosageTimesHint: "設定具體給藥時間,例如:早上8點、晚上8點",
  addTime: "新增時間",
  noMedicationsAdded: "尚未新增藥物。點擊「新增藥物」開始。",
  
  vaccines: "疫苗",
  vaccinesHelpText: "列出所有疫苗和日期",
  vaccinesHint: "例如:狂犬病疫苗、八合一疫苗、萊姆病疫苗、貓三合一",
  nextVetVisit: "下次獸醫看診",
  nextVetVisitHelp: "安排下次獸醫預約",
  allergies: "過敏",
  knownAllergies: "列出任何已知過敏",
  allergiesHint: "例如:花粉、灰塵、雞肉、牛肉、跳蚤、某些藥物",
  medicalConditions: "醫療狀況",
  chronicConditions: "是否有慢性病?",
  medicalConditionsHint: "例如:心臟病、糖尿病、關節炎、腎臟病、癲癇、甲狀腺問題",
  
  veterinarianInfo: "獸醫資訊",
  vetName: "獸醫名稱",
  yourPetsVet: "您的寵物獸醫名稱",
  vetNameHint: "例如:台大動物醫院、愛心動物診所、王醫師",
  vetPhone: "獸醫電話",
  emergencyContactPhone: "緊急聯絡電話",
  vetPhoneHint: "例如:02-12345678、0912-345-678",
  vetAddress: "獸醫地址",
  enterVetAddress: "輸入診所地址",
  vetAddressHint: "例如:台北市大安區信義路四段1號、新北市板橋區中山路123號",
  vetEmail: "獸醫電子郵件",
  enterVetEmail: "輸入獸醫電子郵件",
  vetEmailHint: "例如:clinic@example.com、doctor@vet.com.tw",
  insuranceProvider: "保險公司",
  insuranceProviderHint: "例如:富邦寵物保險、國泰寵物險、新光寵物保",
  insurancePolicy: "保單號碼",
  insurancePolicyHint: "例如:PET2024001234、INS-20240101-001",
  
  specialNotes: "特殊備註",
  additionalInfo: "任何額外資訊",
  specialNotesHint: "例如:怕打雷、對某些聲音敏感、需要特別照護事項、行為習慣提醒",
  
  // Review
  reviewDescription: "儲存前檢視所有資訊",
  profileCompletion: "檔案完成度",
  excellent: "優秀",
  good: "良好",
  minimal: "基本",
  completeReviewTitle: "完整檔案檢視",
  completeProfilePreview: "完整檔案預覽",
  unnamedPet: "未命名寵物",
  notFilled: "未填寫",
  editData: "編輯資料",
  
  // Save & Share
  enterNameToSave: "輸入寵物名稱以啟用儲存",
  fillBasicInfoToSave: "填寫基本資料以儲存",
  petUpdatedSuccessfully: "寵物資料更新成功!",
  petSavedSuccessfully: "寵物資料儲存成功!",
  nowYouCanShare: "您的寵物檔案已準備好分享給他人",
  shareNow: "立即分享",
  backToDashboard: "返回儀表板",
  continueEditing: "繼續編輯",
  errorOccurred: "發生錯誤",
  fixFormErrors: "請修正表單錯誤",
  pleaseCheckAndFixErrors: "請檢查並修正表單中的錯誤",
  saveBeforeShare: "分享前請先儲存",
  needToSaveBeforeSharing: "您需要先儲存寵物檔案才能分享",
  saveAndShare: "儲存並分享",
  
  // Upload
  invalidFileType: "無效的檔案類型。請上傳圖片。",
  fileTooLarge: "檔案太大。最大大小為 5MB。",
  imageStoredLocally: "圖片已本地儲存",
  imageUploadedSuccessfully: "圖片上傳成功!",
  imageStoredAsBase64: "圖片已儲存為 Base64",
  
  // Tag Input
  tagHint: "按 Enter 或逗號新增",
  
  // Time units
  year: "年",
  years: "年",
  month: "個月",
  months: "個月",
  unknown: "未知"
};